import { useCollection } from '@tribeplatform/react-sdk/hooks'
import { SlateRenderer } from '@tribeplatform/slate-kit/components'

import sampleCollectionSlate from '../../samples/collection-slate.json'

type CollectionPageProps = {
  id: string
}

export const CollectionPage = ({ id }: CollectionPageProps) => {
  const { data: collection } = useCollection({
    variables: { id },
    fields: {
      space: 'all',
    },
  })

  return (
    <SlateRenderer
      name="content"
      slate={sampleCollectionSlate}
      type="content"
      additionalContext={{ collection }}
    />
  )
}
